import React from 'react';
import Participant from '../Participant/Participant';
import { styled } from '@mui/material/styles';
import useMainParticipant from '../../hooks/useMainParticipant/useMainParticipant';
import useParticipantsContext from '../../hooks/useParticipantsContext/useParticipantsContext';
import useVideoContext from '../../hooks/useVideoContext/useVideoContext';
import useSelectedParticipant from '../VideoProvider/useSelectedParticipant/useSelectedParticipant';
import useScreenShareParticipant from '../../hooks/useScreenShareParticipant/useScreenShareParticipant';

const Container = styled('aside', {
  shouldForwardProp: (prop) => prop !== 'isTransparent',
})<{ isTransparent: boolean }>(({ theme, isTransparent }) => ({
  display: 'flex',
  height: 'fit-content',
  overflowY: 'initial',
  overflowX: 'hidden',
  gridArea: '1 / 1 / 2 / 3',
  background: isTransparent ? 'transparent' : 'rgb(79, 83, 85)',
  zIndex: 5,
  [theme.breakpoints.down('sm')]: {
    gridArea: '1/ 1 / 2 / 3',
    overflowY: 'initial',
    overflowX: 'hidden',
    display: 'flex',
  },
}));

const ScrollContainer = styled('div')({
  display: 'flex',
  justifyContent: 'flex-start',
});

const InnerScrollContainer = styled('div')(({ theme }) => ({
  width: 'auto',
  padding: `${theme.sidebarMobilePadding}px`,
  display: 'flex',
  [theme.breakpoints.down('sm')]: {
    width: 'auto',
    padding: `${theme.sidebarMobilePadding}px`,
    display: 'flex',
  },
}));

export default function ParticipantList() {
  const { room } = useVideoContext();
  const localParticipant = room!.localParticipant;
  // const participants = useParticipants();
  const { speakerViewParticipants } = useParticipantsContext();
  const [selectedParticipant, setSelectedParticipant] = useSelectedParticipant();
  const screenShareParticipant = useScreenShareParticipant();
  const mainParticipant = useMainParticipant();
  const isLocalParticipantScreenSharing = screenShareParticipant && screenShareParticipant === localParticipant;

  if (speakerViewParticipants.length === 0 && !isLocalParticipantScreenSharing) return null; // Don't render this component if there are no remote participants.

  return (
    <Container isTransparent={!screenShareParticipant}>
      <ScrollContainer>
        <InnerScrollContainer>
          <Participant participant={localParticipant} isLocalParticipant={true} />
          {speakerViewParticipants.map(participant => {
            const isSelected = participant === selectedParticipant;
            const hideParticipant =
              participant === mainParticipant && participant !== screenShareParticipant && !isSelected;
            return (
              <Participant
                key={participant.sid}
                participant={participant}
                isSelected={participant === selectedParticipant}
                onClick={() => setSelectedParticipant(participant)}
                hideParticipant={hideParticipant}
              />
            );
          })}
        </InnerScrollContainer>
      </ScrollContainer>
    </Container>
  );
}
